import React from 'react';
import { DatePickerV2 as DatePickerV2New } from './DatePickerV2';
import { convertOldDatePickerV2Props, OldDatePickerV2Props } from './converter.old';

export type DatePickerV2Props = OldDatePickerV2Props;
export const DatePickerV2: React.FC<DatePickerV2Props> = (props) => (
  <DatePickerV2New {...convertOldDatePickerV2Props(props)} />
);
